// src/utils/dateFormat.ts
//
// 공용 날짜/시간 표시 포맷터.
// ISO 8601 문자열을 받아 사용자에게 보여줄 표현으로 변환한다.
// 입력이 비었거나 파싱 실패 시 안전한 fallback 반환.

import dayjs from "dayjs";

// ISO 8601 형태의 앞부분(연-월-일T시:분:초)을 캡처. 밀리초 + 타임존은 의도적으로 무시.
const ISO_DATETIME_HEAD = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})/;
const ISO_DATE_HEAD = /^(\d{4})-(\d{2})-(\d{2})/;

/** "YYYY.MM.DD" — 날짜만 */
export const fmtDate = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const m = iso.match(ISO_DATE_HEAD);
  if (m) return `${m[1]}.${m[2]}.${m[3]}`;
  // ISO가 아닌 형식이면 dayjs로 한 번 더 시도
  const d = dayjs(iso);
  return d.isValid() ? d.format("YYYY.MM.DD") : iso;
};

/**
 * "YYYY.MM.DD HH:mm:ss" — 초까지, 밀리초/타임존은 버림.
 *
 * dayjs 파싱에 의존하지 않고 정규식으로 ISO 8601의 앞 19자리만 잘라
 * 표현한다. dayjs가 어떤 이유로든(플러그인 미적용, locale 이슈 등)
 * 실패해도 결과가 동일하도록 만들어 두었다.
 */
export const fmtDateTime = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  const m = iso.match(ISO_DATETIME_HEAD);
  if (m) {
    const [, y, mo, d, h, mi, s] = m;
    return `${y}.${mo}.${d} ${h}:${mi}:${s}`;
  }
  // ISO 8601이 아니라면 dayjs로 한 번 더 시도
  const d2 = dayjs(iso);
  return d2.isValid() ? d2.format("YYYY.MM.DD HH:mm:ss") : iso;
};
